import {
  Backdrop,
  CircularProgress,
  Dialog,
  Skeleton,
} from "@mui/material";
import {
  ArrowLeft,
  Check,
  Edit,
  X,
} from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { CalendarFill } from "react-bootstrap-icons";
import DatePicker from "react-datepicker";
import { useParams } from "react-router-dom";
import API from "../../API/newIndex";
import { ChangePathContext } from "../../App";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { GenerateSlugName } from "../../controllers/GenerateSlugName";
import { clientData } from "../../controllers/GetClient";
import ImageConfirmation from "../../controllers/ImageConfirmation";
import ImageGeneratePrompt from "../../controllers/ImageGeneratePrompt";
import ImageUploader from "../../controllers/ImageUploader";
import { parentNavigate } from "../../controllers/ParentNavigate";
import SourceCode from "../../controllers/SourceCode";
import { Transition } from "../../controllers/Transition";
import UpdateCustomMetaField from "../../controllers/UpdateCustomMetaField";
import { useRoutingByType } from "../../controllers/useRouting";
import { useLastRoute } from "../../controllers/LastRouteContext";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import Notification from "../Notification";
import { InputComponent, ButtonComponent, SelectComponent, DetailsComponent, RichTextEditor } from '@shopeasy-dashboard-ui/ui-library';
import TextareaComponent from "../FormInput/TextareaComponent";
import AiTextGenerate from "../AiTextGenerate";

function UpdatePortfolio() {
  const params = useParams();
  const [elem, setElem] = useState();
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [isChange, setIsChange] = useState(false);
  const [image, setimage] = useState();
  const [SelectCategory, setSelectCategory] = useState();
  const [description, setDescription] = useState();
  const [secondDescription, setSecondDescription] = useState();
  const [title, setTitle] = useState();
  const [meta, setMeta] = useState({ meta_description: "", meta_title: "" });
  const [isMetaTitleCustom, setIsMetaTitleCustom] = useState(false);
  const [err, setErr] = useState();
  const [warn, setwarn] = useState();
  const [enableSlug, setEnableSlug] = useState(false);
  const slugInputRef = useRef(null);
  const [slugEdited, setSlugEdited] = useState(false);
  const [slugField, setSlugField] = useState(false);
  const [slugName, setSlugName] = useState();

  const handleSlug = async (slug) => {
    if (slug?.length) {
      setSlugField(true);
      setSlugName(await GenerateSlugName(slug));
    } else {
      setSlugName("");
    }
  };
  const clientInfo = clientData;
  const protocol = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? 'http://' : 'https://';
  const { meta_description, meta_title } = meta;
  const lastRoute = useLastRoute();
  const portfolioRoute = useRoutingByType("portfolio");

  const handleSetImage = (value) => {
    setIsChange(true);
    setimage(value);
  };

  const [formSpinner, setFormSpinner] = useState(true);
  const [scheduleTimeDate, setScheduleTimeDate] = useState();
  const [meta_fields, setmeta_fields] = useState({});
  const [isCustomField, setIsCustomField] = useState(false);

  const getMetaField = async () => {
    const ApiCall = await API({
      url: `/admin/metafieldgroup/getMetaFieldGroup/portfolio`,
      method: "get",
    });
    const result = ApiCall?.data;
    if (result?.data?.custom_fields?.length > 0) {
      setIsCustomField(true);
    }
  };

  const getPerticularPortfolio = async () => {
    setFormSpinner(true);
    try {
      const res = await API({
        url: `/admin/portfolio/getparticularPortfolio/${params.portfolio_slug || window.location.href.split("/").pop()}`,
        method: "get",
      });
      const result = res?.data;
      setElem(result?.data);
      setimage(result?.data?.image);
      setSelectCategory(
        result?.data?.portfoliocategory ? `${result?.data?.portfoliocategory._id}` : "",
      );
      setMeta({
        meta_title: result?.data?.meta_title || "",
        meta_description: result?.data?.meta_description || "",
      });
      setIsMetaTitleCustom(Boolean(result?.data?.meta_title));
      setTitle(result?.data?.title || "");
      setSecondDescription(result?.data?.description || "");
      setScheduleTimeDate(result?.data?.portfolio_publish_date);
      setSlugName(result?.data?.portfolio_slug_name || "");
      setSlugEdited(Boolean(result?.data?.portfolio_slug_name));
      setmeta_fields(result?.data?.custom_fields);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setFormSpinner(false);
  };

  const [Category, setCategory] = useState([]);
  const GetCategory = async () => {
    try {
      const data = await API({
        url: `/admin/portfoliocategory/GetPortfolioCategoriesWithParent`,
        method: "get",
        params: { limit: "all" },
      });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        setCategory(result);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  useEffect(() => {
    getPerticularPortfolio();
    GetCategory();
    getMetaField();
  }, [params?.portfolio_slug]);

  const [btnLoading, setBtnLoading] = useState(false);

  const HandleSubmit = async (e, key, schedule = scheduleTimeDate) => {
    e.preventDefault();
    setBtnLoading(true);
    let body = {
      portfoliocategory: SelectCategory,
      title: title,
      image: image,
      description: secondDescription,
      meta_description,
      meta_title,
      custom_fields: meta_fields,
    };
    if (slugEdited && slugName) {
      body = {
        ...body,
        portfolio_slug_name: slugName,
      };
    }
    if (key === "draft") {
      body = {
        ...body,
        is_draft: true,
      };
    } else if (key === "publish") {
      body = {
        ...body,
        is_draft: false,
      };
    }
    body = {
      ...body,
      portfolio_publish_date: schedule,
    };
    try {
      const payload = body;
      const data = await API({
        url: `/admin/portfolio/updatePortfolio/${elem?._id}`,
        method: "put",
        data: payload,
      });
      if (data.status === 200 || data.status === 304) {
        setIsNotification(true);
        setNotificationMsg("Portfolio Post Updated Successfully");
        setSeverity("success");
        setSaveChanges({
          isUnsaveChanges: false,
          showChangesPopup: false,
          backLink: lastRoute,
          title: "add portfolio",
        });
        parentNavigate(lastRoute);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };

  const handleQuillChange = (value) => {
    setSecondDescription(value);
    setIsChange(true);
  };

  const [AiLoader, setAiloader] = useState(false);
  const [generateAiPopup, setGenareteAiPopup] = useState(false);
  const [generateDescriptionAiPopup, setGenareteDescriptionAiPopup] = useState(false);
  const [gerenateAiData, setGenerateDataAi] = useState({ features: "" });
  const [imageGenerateAiPopup, setImageGenareteAiPopup] = useState(false);
  const [imageGenerateAiData, setImageGenerateDataAi] = useState({
    prompt: "",
    size: "1024x1024",
  });
  const [isConfirmationImageOpen, setIsConfirmationImageOpen] = useState(false);
  const [imageWarn, setImageWarn] = useState(true);
  const [uploadLoader, setUploadLoader] = useState(false);

  const handleChangeAiData = (e) => {
    setGenerateDataAi({ ...gerenateAiData, [e.target.name]: e.target.value });
  };

  const handleSubmitAiData = (e) => {
    e.preventDefault();
    generateDesc(gerenateAiData);
    setGenareteAiPopup(false);
    setGenerateDataAi({ features: "" });
  };

  const generateDesc = async () => {
    setAiloader(true);
    try {
      const payload = { name: gerenateAiData?.features };
      let ApiCall = await API({
        url: "/admin/ai/keypoint_generate",
        data: payload,
        method: "post",
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setDescription(result?.data);
        setGenareteDescriptionAiPopup(true);
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Hit_chatgpt_limit"));
        setSeverity("warning");
      } else {
        setIsNotification(true);
        setNotificationMsg(error?.response?.data?.message);
        setSeverity("error");
      }
    } finally {
      setAiloader(false);
    }
  };

  const [desErr, setDesErr] = useState(false);
  const generateMetaData = async (data, key) => {
    if (secondDescription?.length === 0) {
      setDesErr(true);
    } else {
      setDesErr(false);
      setAiloader(true);
      try {
        const payload = { name: data };
        if (key === "description") {
          let ApiCall = await API({
            url: "/admin/ai/meta_description",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setMeta({ ...meta, meta_description: result?.data });
        } else {
          let ApiCall = await API({
            url: "/admin/ai/meta_title",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setIsMetaTitleCustom(true);
          setMeta((prev) => ({ ...prev, meta_title: result?.data }));
        }
        setIsChange(true);
      } catch (error) {
        if (error?.response?.status === 429) {
          setIsNotification(true);
          setNotificationMsg(t("lang_Hit_chatgpt_limit"));
          setSeverity("warning");
        } else {
          setIsNotification(true);
          setNotificationMsg(error?.response?.data?.message);
          setSeverity("error");
        }
      } finally {
        setAiloader(false);
      }
    }
  };

  const handleChangeImageAiData = (e) => {
    setImageGenerateDataAi({
      ...imageGenerateAiData,
      [e.target.name]: e.target.value,
    });
  };

  const generateImg = async () => {
    setAiloader(true);
    try {
      const payload = imageGenerateAiData;
      let ApiCall = await API({
        url: "/admin/ai/image_generator",
        method: "post",
        data: payload,
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setimage(result?.data[0]);
        setIsConfirmationImageOpen(true);
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Hit_chatgpt_limit"));
        setSeverity("warning");
      } else {
        setIsNotification(true);
        setNotificationMsg(error?.response?.data?.message);
        setSeverity("error");
      }
    } finally {
      setImageGenareteAiPopup(false);
      setAiloader(false);
    }
  };

  const handleSubmitAiImage = (e) => {
    e.preventDefault();
    generateImg(gerenateAiData);
    setImageGenareteAiPopup(false);
    setImageGenerateDataAi({
      prompt: "",
      size: "1024x1024",
    });
  };

  const closeImageConfirmation = () => {
    setIsConfirmationImageOpen(false);
    setimage("");
  };

  const handleImageUpload = async () => {
    setIsConfirmationImageOpen(false);
    try {
      setUploadLoader(true);
      const res = await API({
        url: "/admin/ai/uploadGeneratedImage",
        method: "post",
        data: { imageUrl: image, folder: "portfolio" },
      });
      const result = res?.data;
      setimage(result?.data);
      setIsChange(true);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setUploadLoader(false);
    }
  };

  useEffect(() => {
    if (isChange) {
      setSaveChanges({
        backLink: lastRoute,
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "edit portfolio",
      });
    } else {
      setSaveChanges({
        backLink: lastRoute,
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "edit portfolio",
      });
    }
  }, [isChange]);

  const checkChanges = () => {
    if (isChange) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: lastRoute,
        title: "edit portfolio",
      });
    } else {
      parentNavigate(lastRoute);
    }
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const [isSchedule, setIsSchedule] = useState(false);

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      {AiLoader && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={AiLoader}
          className="flex flex-col"
        >
          <CircularProgress color="inherit" />
          <p>{t("lang_ai_generate_content_loader")}</p>
        </Backdrop>
      )}
      <div className="h-auto overflow-y-auto pb-[130px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_Portfolio_Post"), path: lastRoute },
                    {
                      name: t("lang_Update_Portfolio_Post"),
                      path: "/portfolio/post/edit-portfolio/post",
                    },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Update_Portfolio")} - {elem?.title}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">

          {formSpinner ? (
            <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
              <div className="secondary-bg-color shadow space-y-4 rounded-[6px] p-5 sm:p-[25px]">
                <div className="flex items-center space-x-4 w-full">
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                  </div>
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                  </div>
                </div>
                <div className="w-full">
                  <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                  <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                </div>
                <div className="w-full">
                  <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                  <Skeleton className="w-full min-h-[200px]" variant="rounded-[6px]" />
                </div>
              </div>
              <div className="secondary-bg-color shadow space-y-4 rounded-[6px] p-5 sm:p-[25px]">
                <div>
                  {t("lang_media")}
                  <p className="text-xs table-text font-normal">
                    {t("lang_Update_Portfolio_Details")}
                  </p>
                </div>
                <div className="w-full">
                  <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                  <Skeleton className="w-full min-h-[130px]" variant="rounded-[6px]" />
                </div>
              </div>
            </div>
          ) : (
            <form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              method="POST"
              className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex flex-col gap-3"
            >
              <DetailsComponent
                open={true}
                hasHr={false}
                showChevron={false}
                className="!pt-5 sm:!pt-[25px]"
              >
                <div className="w-full mb-4">
                  <label htmlFor="title" className="flex items-center justify-between">
                    <p className="text-[13px]">
                      {t("lang_Portfolio_Title")}
                      <span className="text-red-500 ms-1">*</span>
                    </p>
                  </label>
                  <InputComponent
                    className={
                      warn
                        ? `border-red-500`
                        : ``
                    }
                    type="text"
                    name="title"
                    value={title}
                    onChange={(e) => {
                      const val = e.target.value;
                      setTitle(val);
                      setwarn(false);
                      setIsChange(true);
                      if (!enableSlug && (!slugEdited || !slugName)) handleSlug(val);
                      if (!isMetaTitleCustom) {
                        setMeta((prev) => ({ ...prev, meta_title: val }));
                      }
                    }}
                    placeholder="e.g. Portfolio title"
                    onBlur={() => {
                      if (!enableSlug && (!slugEdited || !slugName) && title) handleSlug(title);
                      if (!isMetaTitleCustom && !meta_title && title) {
                        setMeta((prev) => ({ ...prev, meta_title: title }));
                      }
                    }}
                  />
                  <div className="flex items-center justify-between mt-1 text-xs text-gray-500 w-full gap-1 min-h-[24px]">
                    <div className="flex items-center w-[90%] min-w-0">
                      <a
                        href={`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/${(slugName || '').toLowerCase()}`}
                        target="_blank"
                        rel="noreferrer"
                        className="font-medium shrink-0 mr-2 hover:underline cursor-pointer text-blue-600 flex items-center"
                      >
                        Preview
                      </a>
                      {/* INLINE EDIT */}
                      {!enableSlug ? (
                        <div className="flex items-center gap-2 min-w-0">
                          <span className="truncate text-gray-500 min-w-0">
                            {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/${(slugName || '').toLowerCase()}`}
                          </span>

                          <button
                            type="button"
                            onClick={() => {
                              setEnableSlug(true);
                              setTimeout(() => slugInputRef.current?.focus(), 50);
                            }}
                            className="text-gray-600 hover:text-black shrink-0 flex items-center"
                          >
                            <Edit size={14} />
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center gap-1 min-w-0 flex-1">
                          <span className="text-gray-400 shrink truncate max-w-[120px] sm:max-w-[200px] md:max-w-[300px] lg:max-w-[400px]">
                            {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${portfolioRoute}/`}
                          </span>

                          <InputComponent
                            ref={slugInputRef}
                            name="portfolio_slug_name"
                            className="flex-1 min-w-[60px] !h-[22px] !py-0.5 !px-1 text-xs"
                            value={slugName || ''}
                            onChange={(e) => {
                              setSlugName(e.target.value);
                              setSlugEdited(Boolean(e.target.value));
                              setIsChange(true);
                            }}
                            onBlur={async () => {
                              if (slugName) {
                                const generated = await GenerateSlugName(slugName);
                                setSlugName(generated);
                              }
                            }}
                            onKeyDown={async (e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                if (!slugName) {
                                  setIsNotification(true);
                                  setSeverity("warning");
                                  setNotificationMsg("Slug can not be empty!");
                                  return;
                                }
                                const generated = await GenerateSlugName(slugName);
                                setSlugName(generated);
                                setEnableSlug(false);
                                setSlugEdited(true);
                              }
                            }}
                            isSlug={true}
                          />

                          <button
                            type="button"
                            className="text-green-600 ml-1 shrink-0 flex items-center"
                            onClick={async () => {
                              if (!slugName) {
                                setIsNotification(true);
                                setSeverity("warning");
                                setNotificationMsg("Slug can not be empty!");
                                return;
                              }

                              const generated = await GenerateSlugName(slugName);
                              setSlugName(generated);
                              setEnableSlug(false);
                              setSlugEdited(true);
                            }}
                          >
                            <Check size={14} />
                          </button>
                        </div>
                      )}
                    </div>

                    <span className={`shrink-0 text-end w-[10%] flex items-center justify-end ${(title?.length || 0) > 60 ? 'text-red-500 font-semibold' : ''}`}>
                      {title?.length || 0}/60
                    </span>
                  </div>

                  {warn && (
                    <p className="text-sm text-red-500 mt-1">{t("lang_Please_Enter_Portfolio_Title")}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label htmlFor="description">{t("lang_Portfolio_Category")}</label>
                  <SelectComponent
                    options={Category?.data?.records?.length
                      ? Category.data.records.map((category) => ({ value: category._id, label: category.parent_category || category.portfoliocategory_name }))
                      : []
                    }
                    value={SelectCategory}
                    onChange={(e) => {
                      setSelectCategory(e.target.value);
                      setIsChange(true);
                    }}
                    placeholder="Select portfolio category"
                    isClearable={false}
                  />
                </div>

                <div>
                  <label htmlFor="Description" className="block mb-1">{t("lang_Portfolio_Description")}</label>
                  <RichTextEditor
                    htmlData={secondDescription}
                    setHtmlData={handleQuillChange}
                    onAiGenerate={() => {
                      if (title === "") {
                        setwarn(true);
                      } else {
                        setGenareteAiPopup(true);
                        setwarn(false);
                      }
                    }}
                    uplaodImageFile={uploadTextEditorImage}
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p className={`text-xs mt-0 ${(secondDescription?.split(/\s+/)?.filter(Boolean)?.length || 0) > 280 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                      {`${secondDescription?.split(/\s+/)?.filter(Boolean)?.length || 0}/280 words`}
                    </p>
                  </div>
                </div>
                <div className="mt-4">
                    <label>
                    {t("lang_Publish_Date") || "Publish Date"}
                  </label>
                  {scheduleTimeDate ? (
                    <div className="flex items-center gap-3">
                      <ButtonComponent
                        variant="outline"
                        type="button"
                        onClick={() => setIsSchedule(true)}
                      >
                        {t("lang_Update_Publish_Date") || "Update publish date"}
                      </ButtonComponent>
                      <div className="flex items-center justify-between px-3 py-2 bg-[#f8fafc] dark:bg-zinc-800/60 border border-gray-200 dark:border-zinc-700 rounded-lg flex-1">
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                          {new Date(scheduleTimeDate).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false,
                          })}
                        </span>
                        <button
                          type="button"
                          className="text-red-500 hover:text-red-600 text-sm font-normal bg-transparent border-none p-0 cursor-pointer ml-3"
                          onClick={() => {
                            setScheduleTimeDate(null);
                            setIsChange(true);
                          }}
                        >
                          {t("lang_Clear") || "Clear"}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-3">
                      <ButtonComponent
                        variant="outline"
                        type="button"
                        onClick={() => setIsSchedule(true)}
                      >
                        {t("lang_Set_Publish_Date") || "Set publish date"}
                      </ButtonComponent>
                    </div>
                  )}
                </div>
              </DetailsComponent>

              <DetailsComponent
                title={
                  <span>
                    {t("lang_media")}
                    <span className="text-red-500 ms-1">*</span>
                  </span>
                }
                subtitle={t("lang_Upload_Captivating_Image_To_Make_Your_Category_Stand_Out")}
                open={true}
              >
                <div>
                  <label htmlFor="Meta Tag Title" className="flex items-center justify-between mb-1">
                    <p>{t("lang_Image")}</p>
                    <span
                      className="inline-flex items-center cursor-pointer hover:underline text-[13px] rounded-[6px] transition duration-300 px-1"
                      onClick={() => setImageGenareteAiPopup(true)}
                    >
                      <BardSvg /> {t("lang_generate_image")}
                    </span>
                  </label>
                  <ImageUploader
                    alreadyImage={image}
                    handleSetImage={handleSetImage}
                    folder="portfolio"
                    format="image"
                  />
                </div>
              </DetailsComponent>

              <DetailsComponent
                title={t("lang_search_engine_listing")}
                subtitle={t("lang_search_engine_listing_detail")}
                contentClassName="px-4 sm:px-[25px] pb-4 sm:pb-[25px]"
              >

                <div className="mb-4">
                  <AiTextGenerate
                    fieldLabel={t("lang_meta_title")}
                    label={t("lang_get_meta_title")}
                    tooltip={t("lang_meta_tooltip", { type: "title" })}
                    onGenerate={() => generateMetaData(secondDescription || title, "title")}
                  />
                  <InputComponent
                    type="text"
                    id="Meta Tag Title"
                    name="meta_title"
                    value={meta_title}
                    onChange={(e) => {
                      setIsMetaTitleCustom(Boolean(e.target.value));
                      setMeta((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                      setIsChange(true);
                    }}
                    placeholder="Enter meta title"
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p className={`text-xs mt-0 ${(meta_title?.length || 0) > 60 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                      {`${meta_title?.length || 0}/60`}
                    </p>
                  </div>
                </div>
                <div>
                  <AiTextGenerate
                    fieldLabel={t("lang_meta_description")}
                    label={t("lang_get_meta_description")}
                    tooltip={t("lang_meta_tooltip", { type: "description" })}
                    onGenerate={() => generateMetaData(secondDescription || description, "description")}
                  />
                  <textarea
                    className="w-full h-24 block px-3 py-2 border border-[var(--border-color)] rounded-lg focus:outline-none focus:border-[var(--focus-border-color)] bg-[var(--secondary-bg-color)] text-[var(--primary-text-color)] text-sm"
                    id="Meta Tag description"
                    name="meta_description"
                    value={(meta_description || '').replace(/<[^>]+>/g, '')}
                    onChange={(e) => {
                      setMeta({ ...meta, [e.target.name]: e.target.value });
                      setIsChange(true);
                    }}
                    placeholder="Enter meta description"
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p className={`text-xs mt-0 ${((meta_description || '').replace(/<[^>]+>/g, '').length || 0) > 160 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                      {`${(meta_description || '').replace(/<[^>]+>/g, '').length || 0}/160 words`}
                    </p>
                  </div>
                </div>
              </DetailsComponent>

              {isCustomField && (
                <UpdateCustomMetaField
                  setmeta_fields={setmeta_fields}
                  meta_fields={meta_fields}
                  heading="portfolio"
                />
              )}
            </form>
          )}
        </div>
      </div>

      <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-4 left-0">
        <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex items-center justify-between">
          <ButtonComponent
            variant="link"
            icon={<ArrowLeft className="w-3 h-3" />}
            onClick={(e) => {
              e.preventDefault();
              checkChanges();
            }}
            className="text-[var(--table-text-color)]"
          >
            {t("lang_Go_To_Portfolio_Post") || "Go to portfolio post"}
          </ButtonComponent>
          <div className="flex items-center gap-3">
            {title === "" || !image?.length || enableSlug ? (
              <>
                <ButtonComponent variant="outline" disabled type="button">
                  {t("lang_Save_As_Draf") || "Save as draft"}
                </ButtonComponent>
                <ButtonComponent variant="primary" disabled type="button">
                  {scheduleTimeDate && new Date(scheduleTimeDate) > new Date()
                    ? (t("lang_Publish_Schedule") || "Publish schedule")
                    : (t("lang_Update_Portfolio_Post") || "Update portfolio post")}
                </ButtonComponent>
              </>
            ) : btnLoading ? (
              <ButtonComponent variant="primary" loading type="button">
                {t("lang_Saving") || "Saving..."}
              </ButtonComponent>
            ) : (
              <>
                <ButtonComponent
                  variant="outline"
                  type="button"
                  onClick={(e) => HandleSubmit(e, "draft")}
                >
                  {t("lang_Save_As_Draf") || "Save as draft"}
                </ButtonComponent>
                <ButtonComponent
                  variant="primary"
                  type="button"
                  onClick={(e) => HandleSubmit(e, "publish")}
                >
                  {scheduleTimeDate && new Date(scheduleTimeDate) > new Date()
                    ? (t("lang_Publish_Schedule") || "Publish schedule")
                    : (t("lang_Update_Portfolio_Post") || "Update portfolio post")}
                </ButtonComponent>
              </>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={generateAiPopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setGenareteAiPopup(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-[350px] md:w-[600px] max-h-full">
          <div className="relative secondary-bg-color shadow dark:bg-gray-700 p-5">
            <div className="flex items-center justify-between border-b main-border-color mb-3 pb-3 rounded-t dark:border-gray-600">
              <h6 className="flex items-center justify-between capitalize font-medium text-primary gap-1">
                <BardSvg /> {t("lang_Generate_Portfolio_Description")}
              </h6>
              <ButtonComponent
                variant="ghost"
                size="sm"
                onClick={() => setGenareteAiPopup(false)}
                className="close-btn !p-1"
              >
                <X className="h-4 w-4" aria-hidden="true" />
              </ButtonComponent>
            </div>
            <form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              onSubmit={handleSubmitAiData}
            >
              <div className="mb-4">
                <TextareaComponent
                  label={t("lang_features_and_keywords")}
                  value={gerenateAiData?.features}
                  name="features"
                  onChange={handleChangeAiData}
                  placeholder="e.g. Modern design, interactive showcase"
                  rows={3}
                />
              </div>
              <ButtonComponent type="submit" variant="primary">
                {t("lang_done")}
              </ButtonComponent>
            </form>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={generateDescriptionAiPopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setGenareteDescriptionAiPopup(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-[350px] md:w-[600px] max-h-full">
          <div className="relative secondary-bg-color shadow dark:bg-gray-700 p-5">
            <div className="flex items-center justify-between border-b main-border-color mb-3 pb-3 rounded-t dark:border-gray-600">
              <h6 className="capitalize font-medium text-primary">
                {t("lang_Generate_Portfolio_Description")}
              </h6>
              <button
                type="button"
                onClick={() => setGenareteDescriptionAiPopup(false)}
                className="close-btn !p-1"
              >
                <X className="h-4 w-4" aria-hidden="true" />
              </button>
            </div>
            <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
              <div className="mb-4">
                <RichTextEditor
                  htmlData={description}
                  setHtmlData={setDescription}
                  uplaodImageFile={uploadTextEditorImage}
                />
              </div>
              <div className="flex justify-between">
                <ButtonComponent
                  type="button"
                  variant="primary"
                  onClick={() => {
                    setSecondDescription(description);
                    setIsChange(true);
                    setGenareteDescriptionAiPopup(false);
                  }}
                >
                  {t("lang_done")}
                </ButtonComponent>
              </div>
            </form>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={isSchedule}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setIsSchedule(false)}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          zIndex: 1000000,
          "& .MuiDialog-paper": {
            zIndex: 1000000,
          },
        }}
      >
        <div className="w-full sm:w-[450px] p-6 rounded-[12px] bg-white dark:bg-zinc-900 text-gray-900 dark:text-zinc-100 shadow-xl flex flex-col">
          <div className="flex items-center justify-between pb-3 mb-4 border-b border-gray-200 dark:border-zinc-800">
            <h5 className="text-base font-semibold text-gray-900 dark:text-white m-0">
              {t("lang_Set_Publish_Date") || "Set publish date"}
            </h5>
            <button
              type="button"
              onClick={() => setIsSchedule(false)}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 p-1 rounded-md transition-colors border-none bg-transparent cursor-pointer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="relative">
              <input
                type="text"
                readOnly
                value={
                  scheduleTimeDate
                    ? new Date(scheduleTimeDate).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    }) +
                    " " +
                    new Date(scheduleTimeDate).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                    : ""
                }
                placeholder={t("lang_Select_Date_Time") || "Select date & time"}
                className="w-full px-3 py-2 border border-gray-200 dark:border-zinc-700 rounded-lg text-sm bg-gray-50 dark:bg-zinc-800 text-gray-900 dark:text-white pr-10 focus:outline-none"
              />
              <CalendarFill className="absolute right-3 top-3 w-4 h-4 text-gray-400" />
            </div>

            <div className="w-full min-h-[290px] custom-datepicker-inline flex justify-center">
              <div className="relative w-full flex justify-center">
                <DatePicker
                  className={`${scheduleTimeDate ? "bold-date" : ""} w-full px-3 py-2 border main-border-color rounded-[6px] focus:outline-none focus:border-gray-400`}
                  showTimeSelect
                  inline
                  selected={scheduleTimeDate ? new Date(scheduleTimeDate) : null}
                  onChange={(date) => {
                    setScheduleTimeDate(date);
                    setIsChange(true);
                  }}
                  dateFormat="MMMM d, yyyy h:mm aa"
                />
              </div>
            </div>

            <div className="pt-2">
              <ButtonComponent
                variant="primary"
                type="button"
                onClick={() => setIsSchedule(false)}
              >
                {t("lang_Done") || "Done"}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </Dialog>

      {imageGenerateAiPopup && (
        <ImageGeneratePrompt
          imageGenerateAiPopup={imageGenerateAiPopup}
          setImageGenareteAiPopup={setImageGenareteAiPopup}
          imageGenerateAiData={imageGenerateAiData}
          imageWarn={imageWarn}
          setImageWarn={setImageWarn}
          handleChangeImageAiData={handleChangeImageAiData}
          handleSubmitAiImage={handleSubmitAiImage}
        />
      )}

      {isConfirmationImageOpen && (
        <ImageConfirmation
          heading="Image Confirmation"
          subheading="Do you want to keep this image in portfolio?"
          image={image}
          isConfirmationImageOpen={isConfirmationImageOpen}
          closeImageConfirmation={closeImageConfirmation}
          runFunction={handleImageUpload}
        />
      )}
    </>
  );
}

export default UpdatePortfolio;
